export const dateFromNow = (
  date: Date,
  now?: Date
): { seconds: number; minutes: number; hours: number; days: number; months: number } => {
  const nowTime = new Date(now || Date.now()).valueOf()
  const diffTime = date.valueOf()
  const fromNowDiff = diffTime - nowTime

  return {
    months: Math.round(fromNowDiff / 1000 / 60 / 60 / 24 / 30),
    days: Math.round(fromNowDiff / 1000 / 60 / 60 / 24),
    hours: Math.round(fromNowDiff / 1000 / 60 / 60),
    minutes: Math.round(fromNowDiff / 1000 / 60),
    seconds: Math.round(fromNowDiff / 1000),
  }
}

export const formatFromNow = ({
  seconds = 0,
  minutes = 0,
  hours = 0,
  days = 0,
  months = 0,
}: {
  seconds?: number
  minutes?: number
  hours?: number
  days?: number
  months?: number
}): string => {
  if (months >= 1) {
    return months === 1 ? `a month ago` : `${months} months ago`
  } else if (days >= 1) {
    return days === 1 ? `${days} day ago` : `${days} days ago`
  } else if (hours >= 1) {
    return hours === 1 ? `${hours} hour ago` : `${hours} hours ago`
  } else if (minutes >= 1) {
    return minutes === 1 ? `${minutes} minute ago` : `${minutes} minutes ago`
  } else if (seconds >= 1) {
    return seconds === 1 ? `${seconds} second ago` : `${seconds} seconds ago`
  } else {
    return ''
  }
}

export const timeAgo = (date: Date): string => {
  const fromNow = dateFromNow(date)
  return formatFromNow({
    months: Math.abs(fromNow.months),
    days: Math.abs(fromNow.days),
    hours: Math.abs(fromNow.hours),
    minutes: Math.abs(fromNow.minutes),
    seconds: Math.abs(fromNow.seconds),
  })
}
